import type { FaireCategoryEntity } from "../../entity_types/category";

export const cat_beauty_fragrance: FaireCategoryEntity = {
  token: "cat_beauty-fragrance",
  type: "category",
  name: "Fragrance",
  level: 2,
  parentToken: "cat_beauty-wellness",
  href: "/category/fragrance",
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
